import React, { useEffect, useState } from "react";
import { Box, Button, Container, Typography, Paper, Grid } from "@mui/material";
import { IconMailCheck } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import PageContainer from "../MainPages/PageContainer";
import SignInImage from '../../Images/smilingman1.png';

const EmailVerification = () => {
    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const userid = params.get("userid");
    const Email = params.get("email")
    const Otp = params.get("otp")
    const [enablebutton, setEnableButton] = useState(false)
    const [error, seterror] = useState('')
    const [ShowSuccess,setShowSuccess]= useState(false)
    const Submit = async () => {
        let req = {
            otp: Otp,
            phone: Email,
            user_id: userid
        }
        try {
            const response = await axios.post("/apiV1/email-verify/", req)
            if (response.status == 200) {
                setShowSuccess(true)                
            }

        }
        catch (err) {
            console.log(err);
            seterror(err.response.data.message)
        }
    }
    const resendOtp = async () => {
        try {
            let req = {
                phone: Email
            }
            const response = await axios.post(`/apiV1/resend-otp-email/`, req)
            console.log(response);
        } catch (err) {
            console.log(err);
            seterror(err.response.data.message)

        }
    }
    useEffect(() => {
        Submit()
    }, [])
    useEffect(() => {
        const timer = setTimeout(() => {
            setEnableButton(true);
        }, 6000);

        return () => clearTimeout(timer);
    }, []);
    return (
        <>
            <PageContainer title="Auto SDLC | Sign In">
                <Container maxWidth={false} sx={{ height: '100vh', display: 'flex' }}>
                    <Grid container>
                        <Grid
                            item
                            xs={12}
                            md={5}
                            sx={{
                                bgcolor: '#fff',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                p: 2
                            }}
                        >
                            <Box
                                sx={{
                                    background: 'linear-gradient(166deg, #082A68 0%, #591CC2 100%)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    p: 22,
                                    width: '100%',
                                    borderRadius: 2,
                                    color: "#fff"
                                }}
                            >
                                <Box
                                    component="img"
                                    src={SignInImage}
                                    alt="Sign In"
                                    sx={{ maxWidth: '90%', height: 'auto', mb: 4 }}
                                />
                                <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
                                Welcome to Auto SDLC!
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 4 }}>
                                Secure your journey with confidence! Your account is now verified, and you're one step closer to unlocking amazing opportunities.
                                </Typography>
                            </Box>
                        </Grid>

                        {/* Right Section */}
                        <Grid
                            item
                            xs={12}
                            md={7}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                p: 4,
                                bgcolor: "#fff",
                            }}
                        >
                            <Box sx={{ textAlign: "center" }}>
                            {ShowSuccess ?<> <Typography variant="h5" fontWeight="bold" sx={{ textAlign: "center" }}>
                                    Email Verified Successfully!
                                </Typography>
                                <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                                    <IconMailCheck size={60} color="#4CAF50" />
                                </Box></>:<Typography variant="h5" fontWeight="bold" sx={{ textAlign: "center" }}>
                                    Verify Your Email
                                </Typography>}
                                <Typography variant="body1" color="textSecondary" sx={{ mt: 1, mb: 3 }}>
                                    {error}
                                </Typography>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center", 
                                        justifyContent: "center", 
                                        gap: 2,
                                        width: "100%", 
                                        mt: 2, 
                                    }}
                                >
                                    <Button variant="contained" color="primary" sx={{ width: "250px" }} onClick={() => navigate("/")}>
                                        Go to Login
                                    </Button>
                                    {/* <Button variant="outlined" color="secondary" sx={{ width: "250px" }} onClick={resendOtp} disabled={!enablebutton}>
                                        Resend Link
                                    </Button> */}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </PageContainer>
        </>
    )
};

export default EmailVerification;
